import { useQuery } from '@tanstack/react-query';
import { ctcApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

const REFERENCE_STALE_TIME = 5 * 60_000;

export function useDivisions() {
  return useQuery({
    queryKey: queryKeys.organization.divisions(),
    queryFn: ({ signal }) =>
      ctcApiClient.listCTCDivisions(toCancelToken(signal)),
    staleTime: REFERENCE_STALE_TIME,
    meta: {
      suppressErrorToast: true,
      errorContext: 'organization divisions',
    },
  });
}
